export const CLICK_UPLOAD_DOCS_SEND_LINK = 'CLICK_UPLOAD_DOCS_SEND_LINK';
export const CLICK_CREDIT_APP_SEND_LINK = 'CLICK_CREDIT_APP_SEND_LINK';
export const CLICK_TEST_DRIVE_SEND_LINK = 'CLICK_TEST_DRIVE_SEND_LINK';
export const CLICK_CUSTOMER_NAME_OR_CO_BUYER_LINK = 'CLICK_CUSTOMER_NAME_OR_CO_BUYER_LINK';
export const CLICK_OPEN_DEAL_IN_FI_BUTTON = 'CLICK_OPEN_DEAL_IN_FI_BUTTON';
export const CLICK_CREDIT_BUREAU_SCORES_LINK = 'CLICK_CREDIT_BUREAU_SCORES_LINK';
export const SELECT_OFFER_CREDIT_RATING_DROPDOWN = 'SELECT_OFFER_CREDIT_RATING_DROPDOWN';
export const VIEW_IN_VAUTO_LINK = 'VIEW_IN_VAUTO_LINK';

export const CLICK_MAKE_CURRENT_BUTTON = 'CLICK_MAKE_CURRENT_BUTTON';
export const CLICK_MAKE_CURRENT_LINK = 'CLICK_MAKE_CURRENT_LINK';
export const CLICK_VALUE_TRADE_IN_START_LINK = 'CLICK_VALUE_TRADE_IN_START_LINK';
export const CLICK_TRADE_IN_EDIT_BUTTON = 'CLICK_TRADE_IN_EDIT_BUTTON'; // dc-mv-310
export const CLICK_VEHICLE_DETAILS_LINK = 'CLICK_VEHICLE_DETAILS_LINK';
export const CLICK_QUICK_COMPARE_LINK = 'CLICK_QUICK_COMPARE_LINK';
export const CLICK_OFFER_HISTORY_BUTTON = 'CLICK_OFFER_HISTORY_BUTTON';
export const CLICK_DEAL_PROGRESS_UPDATE_BUTTON = 'CLICK_DEAL_PROGRESS_UPDATE_BUTTON';

export const CLICK_TRADE_INCLUDE_WITH_OFFER_CHECKBOX = 'CLICK_TRADE_INCLUDE_WITH_OFFER_CHECKBOX';
export const CLICK_START_APPRAISAL_LINK = 'CLICK_START_APPRAISAL_LINK'; // dc-mv-210
export const CLICK_ADD_ACCESSORIES_LINK = 'CLICK_ADD_ACCESSORIES_LINK';
export const CLICK_PROGRAMS_AND_INCENTIVES_ADD_LINK = 'CLICK_PROGRAMS_AND_INCENTIVES_ADD_LINK';
export const CLICK_VEHICLE_ACCESSORIES_START_LINK = 'CLICK_VEHICLE_ACCESSORIES_START_LINK';
export const CLICK_VEHICLE_ACCESSORIES_EDIT_LINK = 'CLICK_VEHICLE_ACCESSORIES_EDIT_LINK';
export const CLICK_VEHICLE_PROTECTION_START_LINK = 'CLICK_VEHICLE_PROTECTION_START_LINK';
export const CLICK_VEHICLE_PROTECTION_EDIT_LINK = 'CLICK_VEHICLE_PROTECTION_EDIT_LINK';
export const CLICK_APPLY_VEHICLE_PROTECTION_BUTTON = 'CLICK_APPLY_VEHICLE_PROTECTION_BUTTON';
export const CLICK_OPEN_FLEXIBLE_PROTECTION_PRODUCTS_ENTRY_LINK = 'CLICK_OPEN_FLEXIBLE_PROTECTION_PRODUCTS_ENTRY_LINK';
export const CLICK_REMOVE_MANUALLY_ADDED_PROTECTION_PRODUCT_ICON = 'CLICK_REMOVE_MANUALLY_ADDED_PROTECTION_PRODUCT_ICON';
export const CLICK_OPEN_VEHICLE_PROTECTION_FROM_CATALOG_LINK = 'CLICK_OPEN_VEHICLE_PROTECTION_FROM_CATALOG_LINK';
export const UPDATE_ADD_PROTECTION_PRODUCT_MANUALLY_TEXT_INPUT = 'UPDATE_ADD_PROTECTION_PRODUCT_MANUALLY_TEXT_INPUT';
export const CLICK_PROGRAMS_AND_INCENTIVES_START_LINK = 'CLICK_PROGRAMS_AND_INCENTIVES_START_LINK';
export const CLICK_PROGRAMS_AND_INCENTIVES_EDIT_LINK = 'CLICK_PROGRAMS_AND_INCENTIVES_EDIT_LINK';
export const CLICK_APPLY_PROGRAMS_AND_INCENTIVES_BUTTON = 'CLICK_APPLY_PROGRAMS_AND_INCENTIVES_BUTTON';

export const UPDATE_ACQ_FEE_TEXT_INPUT = 'UPDATE_ACQ_FEE_TEXT_INPUT';
export const CLICK_ACQ_FEE_UPFRONT_CHECKBOX = 'CLICK_ACQ_FEE_UPFRONT_CHECKBOX';
export const UPDATE_SECURITY_DEPOSIT_TEXT_INPUT = 'UPDATE_SECURITY_DEPOSIT_TEXT_INPUT';
export const UPDATE_COST_PER_MILE_TEXT_INPUT = 'UPDATE_COST_PER_MILE_TEXT_INPUT';
export const UPDATE_BASE_RESIDUAL_TEXT_INPUT = 'UPDATE_BASE_RESIDUAL_TEXT_INPUT';
export const CLICK_BASE_RESIDUAL_DOLLARS_BUTTON = 'CLICK_BASE_RESIDUAL_DOLLARS_BUTTON';
export const CLICK_BASE_RESIDUAL_PERCENT_BUTTON = 'CLICK_BASE_RESIDUAL_PERCENT_BUTTON';
export const UPDATE_ADJUSTED_RESIDUAL_TEXT_INPUT = 'UPDATE_ADJUSTED_RESIDUAL_TEXT_INPUT';
export const CLICK_ADJUSTED_RESIDUAL_DOLLARS_BUTTON = 'CLICK_ADJUSTED_RESIDUAL_DOLLARS_BUTTON';
export const CLICK_ADJUSTED_RESIDUAL_PERCENT_BUTTON = 'CLICK_ADJUSTED_RESIDUAL_PERCENT_BUTTON';
export const SELECT_MILES_PER_YEAR_DROPDOWN = 'SELECT_MILES_PER_YEAR_DROPDOWN';

export const UPDATE_CASH_MSRP_TEXT_INPUT = 'UPDATE_CASH_MSRP_TEXT_INPUT';
export const UPDATE_CASH_SELLING_PRICE_TEXT_INPUT = 'UPDATE_CASH_SELLING_PRICE_TEXT_INPUT';
export const UPDATE_FINANCE_MSRP_TEXT_INPUT = 'UPDATE_FINANCE_MSRP_TEXT_INPUT';
export const UPDATE_FINANCE_SELLING_PRICE_TEXT_INPUT = 'UPDATE_FINANCE_SELLING_PRICE_TEXT_INPUT';
export const UPDATE_FINANCE_CASH_DOWN_TEXT_INPUT = 'UPDATE_FINANCE_CASH_DOWN_TEXT_INPUT';
export const SELECT_FINANCE_LENDER_DROPDOWN = 'SELECT_FINANCE_LENDER_DROPDOWN'; // dc-mv-55
export const UPDATE_FINANCE_TERM_DROPDOWN = 'UPDATE_FINANCE_TERM_DROPDOWN';
export const UPDATE_LEASE_MSRP_TEXT_INPUT = 'UPDATE_LEASE_MSRP_TEXT_INPUT';
export const UPDATE_LEASE_SELLING_PRICE_TEXT_INPUT = 'UPDATE_LEASE_SELLING_PRICE_TEXT_INPUT';
export const UPDATE_LEASE_CASH_DOWN_TEXT_INPUT = 'UPDATE_LEASE_CASH_DOWN_TEXT_INPUT';
export const SELECT_LEASE_LENDER_DROPDOWN = 'SELECT_LEASE_LENDER_DROPDOWN'; // dc-mv-98
export const UPDATE_LEASE_TERM_DROPDOWN = 'UPDATE_LEASE_TERM_DROPDOWN';
export const SELECT_FINANCE_LENDER_DECISION_DROPDOWN = 'SELECT_FINANCE_LENDER_DECISION_DROPDOWN';
export const UPDATE_FINANCE_SELL_RATE_TEXT_INPUT = 'UPDATE_FINANCE_SELL_RATE_TEXT_INPUT';
export const UPDATE_FINANCE_BUY_RATE_TEXT_INPUT = 'UPDATE_FINANCE_BUY_RATE_TEXT_INPUT';
export const SELECT_LEASE_LENDER_DECISION_DROPDOWN = 'SELECT_LEASE_LENDER_DECISION_DROPDOWN';
export const UPDATE_LEASE_SELL_RATE_TEXT_INPUT = 'UPDATE_LEASE_SELL_RATE_TEXT_INPUT';
export const UPDATE_LEASE_BUY_RATE_TEXT_INPUT = 'UPDATE_LEASE_BUY_RATE_TEXT_INPUT';

export const CLICK_GENERATE_CONTRACT_BUTTON = 'CLICK_GENERATE_CONTRACT_BUTTON';
export const CLICK_GENERATE_CONTRACT_CONFIRM_BUTTON = 'CLICK_GENERATE_CONTRACT_CONFIRM_BUTTON';
export const CLICK_MANAGE_DOCUMENTS_BUTTON = 'CLICK_MANAGE_DOCUMENTS_BUTTON';
export const CLICK_PRINT_BUTTON = 'CLICK_PRINT_BUTTON';
export const CLICK_FUNCTIONS_BUTTON = 'CLICK_FUNCTIONS_BUTTON';
export const CLICK_DEAL_TYPE_DROPDOWN_FINANCE = 'CLICK_DEAL_TYPE_DROPDOWN_FINANCE';
export const CLICK_DEAL_TYPE_DROPDOWN_LEASE = 'CLICK_DEAL_TYPE_DROPDOWN_LEASE';
export const CLICK_DEAL_TYPE_DROPDOWN_CASH = 'CLICK_DEAL_TYPE_DROPDOWN_CASH';
export const CLICK_DEAL_LIST_LINK = 'CLICK_DEAL_LIST_LINK';
export const CLICK_ROLL_TO_PAYMENT_APPLY_BUTTON = 'CLICK_ROLL_TO_PAYMENT_APPLY_BUTTON';

export const CLICK_PUSH_TO_DARWIN_BUTTON = 'CLICK_PUSH_TO_DARWIN_BUTTON';
export const OPEN_IN_DARWIN_BUTTON = 'OPEN_IN_DARWIN_BUTTON';
export const ADD_ANOTHER_TRADEIN_LINK = 'ADD_ANOTHER_TRADEIN_LINK';
export const DELETE_TRADEIN_ICON = 'DELETE_TRADEIN_ICON';
export const TRADEIN_VEHICLE_ACCORDION_SUMMARY = 'TRADEIN_VEHICLE_ACCORDION_SUMMARY';

export const CLICK_ALTERNATIVE_VEHICLE_OPTIONS_LINK = 'CLICK_ALTERNATIVE_VEHICLE_OPTIONS_LINK';
export const CLICK_LENDER_APPROVAL_LIKELIHOOD_LINK = 'CLICK_LENDER_APPROVAL_LIKELIHOOD_LINK';
export const LENDER_APPROVAL_LIKELIHOOD_VIEWED = 'LENDER_APPROVAL_LIKELIHOOD_VIEWED';

export const CLICK_MV_ACCESSORIES_LINK = 'CLICK_MV_ACCESSORIES_LINK';
export const CLICK_MV_LENDER_LINK = 'CLICK_MV_LENDER_LINK';
export const CLICK_MV_RATE_LINK = 'CLICK_MV_RATE_LINK';
export const CLICK_MV_INCENTIVES_LINK = 'CLICK_MV_INCENTIVES_LINK';
export const CLICK_MV_PROTECTION_LINK = 'CLICK_MV_PROTECTION_LINK';
export const CLICK_MV_TAXES_LINK = 'CLICK_MV_TAXES_LINK';
export const CLICK_MV_FEES_LINK = 'CLICK_MV_FEES_LINK';
export const CLICK_MV_TRADE_ALLOWANCE_LINK = 'CLICK_MV_TRADE_ALLOWANCE_LINK';
export const CLICK_MV_TRADE_PAYOFF_LINK = 'CLICK_MV_TRADE_PAYOFF_LINK';

export const CLICK_MV_CHANGE_VEHICLE = 'CLICK_MV_CHANGE_VEHICLE';
export const CLICK_MV_CHANGE_TO_FI_MODE = 'CLICK_MV_CHANGE_TO_FI_MODE';
export const CLICK_MV_CHANGE_TO_DESKING_MODE = 'CLICK_MV_CHANGE_TO_DESKING_MODE';

export const CLICK_APPRAISE_TRADE_IN_VEHICLE_LINK = 'CLICK_APPRAISE_TRADE_IN_VEHICLE_LINK'; // dc-mv-307
export const APPRAISAL_SLIDE_PANEL_CALLBACK_RECEIVED = 'APPRAISAL_SLIDE_PANEL_CALLBACK_RECEIVED'; // dc-mv-309
export const TRADE_IN_INFO_UPDATE_APPLIED = 'TRADE_IN_INFO_UPDATE_APPLIED'; // dc-mv-316
export const CLICK_OPEN_REPAIR_ORDERS_LINK = 'CLICK_OPEN_REPAIR_ORDERS_LINK'; // dc-mv-327
export const OPEN_REPAIR_ORDERS_SLIDE_OUT_VIEWED = 'OPEN_REPAIR_ORDERS_SLIDE_OUT_VIEWED'; // dc-mv-328
export const CLICK_SWAP_BUYER_CO_BUYER_BUTTON = 'CLICK_SWAP_BUYER_CO_BUYER_BUTTON'; // dc-mv-329
